import NewForm from 'components/NewForm';
import React, { useEffect, useState } from 'react';
import profileService from 'services/profile.service';
import { useSessionStorageTempPage } from 'utils/useLocalStorage';
import "./../style-profile-page.scss";

interface IProfileType{
  id: number;
  name: string;
  description: string;
}

function SelectProfileType({
  name, onChange, value
}:{
  name?:string;
  onChange?:(event:any)=>void;
  value?:any;
}){
  const [ list, setList ] = useSessionStorageTempPage<IProfileType[]>("profile_types",[]);
  useEffect(()=>{
    if(list.length===0){
      profileService.getTypes<IProfileType[]>().then((data)=>{
        setList(data);
      })
    }
  },[list, setList]);

  return (
    <div className="area-list-profile-type">
      {list.map((item,key)=>{
        return (
          <div className="area-item-profile-type" key={key}>
            <div className="item-check" onClick={(e)=>{
              let element:any = e.currentTarget;
              if(element){
                try {
                  element.getElementsByTagName("input")[0].checked = true;
                  if(onChange) onChange(item.id);
                } catch (error) {}
              }
            }}>
              <input
                type="radio"
                value={item.id}
                name={name}
                defaultChecked={value && value === item.id}
              />
              <div className="checkdot"></div>
            </div>
            <div className="item-title-profile-type">{item.name}</div> 
            <div className="item-description-profile-type">{item.description}</div> 
          </div>
        );
      })}
    </div>
  );
}

export default function ProfileData(props?:any){
  const [Model, SetModel] = useState<any>(props.model);

  useEffect(()=>{
    props.setModel(Model);
  },[Model,props])

  return (
    <div>
      <NewForm title="Profile Type">
        <SelectProfileType name="profile_type_id" onChange={(e)=>{
          SetModel((old:any) => ({...old, profile_type_id:e}))
        }}
        value={Model.profile_type_id}/>
      </NewForm>
      <NewForm title="Perfil">
        <NewForm.Input title="Nome" md="4" name="name" state={props}/>
        {/* <NewForm.Textarea title="Descricao" xs="12" name="description" state={{model:Model, setModel:SetModel}}/> */}
      </NewForm>
    </div>
  );
}